import { APIClient, setLanguage } from 'services/helpers/api_helper';

import * as url from 'services/helpers/url_helper';

import { UserLoginBody } from 'types/AuthTypes';
import { MerchantInfoResponse } from 'types/APIResponsesTypes';

const api = new APIClient();

export const postJwtLogin = async (data: UserLoginBody) => {
  setLanguage();

  try {
    const response = await api.create(url.POST_LOGIN, data);
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getMyAccount = async () => {
  try {
    const response = await api.get(url.GET_MY_ACCOUNT, '');

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getMerchant = async (): Promise<MerchantInfoResponse> => {
  try {
    const response = await api.get(url.GET_MERCHANT_ME);

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const postLogout = async () => {
  try {
    const response = await api.create(url.POST_LOGOUT, {});
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getCheckLogin = async () => {
  try {
    const options = process.env.NODE_ENV !== 'development' ? {} : { dev: 1 };
    const response = await api.get(url.GET_CHECK_LOGIN, options);
    const hasToken = response.authenticated ? response.authenticated : false;
    if (process.env.NODE_ENV !== 'development') {
      sessionStorage.setItem('url', response.url);
    }
    return hasToken;
  } catch (error) {
    console.log(error);
    return false;
  }
};
